module.exports = __webpack_public_path__ + "img/fast-forward.cf478035.svg";